module.exports = __webpack_public_path__ + "static/hf3-9-ed561a010563bf24d5c66c1198d71db7.gif";